<template>
    <div>
        <b-card class="standardpage">
            <div class="animated fadeIn">
                <b-row>
                    <b-col sm="6" lg="2" v-if="permissionvalid('bookingforms.admin')">
                        <b-card @click="selectedComponent = 'Bhold'" class="onhover">
                            <div :class="selectedComponent == 'Bhold' ? 'highlight-triangle sm success' : null"></div>
                            <b-row>
                                <b-col class="h1 m-0">{{ $store.state.bookingforms.length }}</b-col>
                                <b-col class="h1 text-muted text-right mb-2"> <i
                                        class="fa fa-balance-scale text-secondary"></i></b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <div>Bhold (Accounts Only)</div>
                                    <small class="text-muted">Booking forms to be invoiced.</small>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                    <b-col sm="6" lg="2" v-else>
                        <b-card @click="selectedComponent = 'Bform'" class="onhover">
                            <div :class="selectedComponent == 'Bform' ? 'highlight-triangle sm success' : null"></div>

                            <b-row>
                                <b-col class="h1 m-0">{{ $store.state.bookingforms.length }}</b-col>
                                <b-col class="h1 text-muted text-right mb-2"> <i
                                        class="fa fa-tasks text-secondary"></i></b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <div>Booking Forms</div>
                                    <small class="text-muted">Submit booking form charges.</small>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                    <!-- v-if="permissionvalid('conferma.view')" -->
                    <b-col sm="6" lg="2">
                        <b-card @click="selectedComponent = 'Chold'" class="onhover">
                            <div :class="selectedComponent == 'Chold' ? 'highlight-triangle sm success' : null"></div>
                            <b-row>
                                <b-col class="h1 m-0">{{ $store.state.chold.length }}</b-col>
                                <b-col class="h1 text-muted text-right mb-2">
                                    <i class="fa fa-credit-card text-purple"></i></b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <div>Chold Inventory</div>
                                    <small class="text-muted">Conferma charges to be invoiced.</small>
                                </b-col>
                            </b-row>

                        </b-card>
                    </b-col>
                    <!-- v-if="permissionvalid('carhire.view')" -->
                    <b-col sm="6" lg="2"
                        v-if="user.department.toLowerCase() == 'events' || user.department.toLowerCase() == 'accounts' || user.department.toLowerCase() == 'development'">
                        <b-card @click="selectedComponent = 'Ghold'" class="onhover">
                            <div :class="selectedComponent == 'Ghold' ? 'highlight-triangle sm success' : null"></div>
                            <b-row>
                                <b-col class="h1 m-0">{{ $store.state.ghold.length }}</b-col>
                                <b-col class="h1 text-muted text-right mb-2">
                                    <i class="fa fa-bus text-dark dark-switch"></i></b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <div>Ghold Inventory</div>
                                    <small class="text-muted">Ground charges to be invoiced.</small>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>

                    <!-- v-if="permissionvalid('amex.view')" -->
                    <b-col sm="6" lg="2">
                        <b-card @click="selectedComponent = 'Xhold'" class="onhover">
                            <div :class="selectedComponent == 'Xhold' ? 'highlight-triangle sm success' : null"></div>
                            <b-row>
                                <b-col class="h1 m-0">{{ $store.state.xhold.length }}</b-col>
                                <b-col class="h1 text-muted text-right mb-2">
                                    <i class="fa fa-cc-amex text-info"></i></b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <div>Xhold Inventory</div>
                                    <small class="text-muted">AMEX charges to be invoiced.</small>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>

                    <!-- v-if="permissionvalid('zhold.view')" -->
                    <b-col sm="6" lg="2">
                        <b-card @click="selectedComponent = 'Zhold'" class="onhover">
                            <div :class="selectedComponent == 'Zhold' ? 'highlight-triangle sm success' : null"></div>
                            <b-row>
                                <b-col class="h1 m-0">{{ $store.state.zhold.length }}</b-col>
                                <b-col class="h1 text-muted text-right mb-2">
                                    <i class="fa fa-ticket text-orange"></i></b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <div>Zhold Inventory</div>
                                    <small class="text-muted">Tickets to be invoiced.</small>
                                </b-col>
                            </b-row>


                        </b-card>
                    </b-col>
                    <!-- v-if="permissionvalid('queue.view')" -->
                    <b-col sm="6" lg="2">
                        <b-card @click="selectedComponent = 'Queue'" class="onhover">
                            <div :class="selectedComponent == 'Queue' ? 'highlight-triangle sm success' : null"></div>
                            <b-row>
                                <b-col class="h1 m-0">{{ $store.state.queued.length }}</b-col>
                                <b-col class="h1 text-muted text-right mb-2">
                                    <i class="fa fa-stack-overflow text-warning"></i></b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <div>Zhold Queue</div>
                                    <small class="text-muted">Tickets on the invoice queue.</small>
                                </b-col>
                            </b-row>


                        </b-card>
                    </b-col>
                    <!-- <b-col sm="6" lg="3">
                        <b-card>
                            <div class="h4 m-0">2 TB</div>
                            <div>Lorem ipsum...</div>
                            <b-progress height={} class="progress-xs my-3" variant="danger" :value="25" />
                            <small class="text-muted">Lorem ipsum dolor sit amet enim.</small>
                        </b-card>
                    </b-col> -->
                </b-row><!--/.row-->
                <b-row v-if="!selectedComponent" class="mt-2 px-3">
                    <b-col>
                        <b-alert :show="true" variant="danger">
                            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                    <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                <b-col>
                                    You account is not setup for invoicing.</b-col></b-row>
                        </b-alert></b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-alert :show="invoicing_message?true:false" :variant="invoicing_enabled=='yes'?'primary':'danger'">
                            <b-row  align-h="center" align-v="center" no-gutters>
                                <b-col cols="auto mr-3">
                                    <i class="fa fa-exclamation-circle fa-2x"></i>
                                </b-col>
                                <b-col cols="auto">{{ invoicing_message }}</b-col>
                            </b-row>
                        </b-alert>
                    </b-col>
                </b-row>
             
            </div>
            <b-row class="divider mb-4" no-gutters>
            </b-row>

            <div v-if="selectedComponent" class="mt-2">
                <keep-alive>
                    <component :is="selectedComponent" />
                </keep-alive>
            </div>
        </b-card>
    </div>
</template>

<script>

// import Ihold from "./Invoicing/Ihold";
import Bform from "../Apps/Accounts/BookingForms2.vue";
import Bhold from "./Invoicing/Bhold";
import Chold from "./Invoicing/Chold";
import Ghold from "./Invoicing/Ghold";
import Xhold from "./Invoicing/Xhold";
import Zhold from "./Invoicing/Zhold";
import Queue from "./Invoicing/Queue";

export default {
    name: "Invoicing",
    components: {
        // Ihold,
        Bform,
        Bhold,
        Chold,
        Ghold,
        Xhold,
        Zhold,
        Queue,
    },
    async mounted() {
        // if (this.permissionvalid('zhold.view')) {
        //     this.selectedComponent = "Zhold"
        // }
        // if (this.permissionvalid('conferma.view')) {
        //     this.selectedComponent = "Chold"
        // }

        if (this.user.department == 'F1') {
            this.selectedComponent = "Zhold"
        } else {
            this.selectedComponent = "Chold"
        }

        this.invoicing_message = await this.getsystemsetting("invoicing_message");
        this.invoicing_enabled = await this.getsystemsetting("invoicing_enabled");

    },
    data() {
        return {
            busy: false,
            selectedComponent: null,
            invoicing_message: null,
            invoicing_enabled: null
        }
    }
}
</script>